import { render, staticRenderFns } from "./ChargesStat.vue?vue&type=template&id=0ffb06b4&"
import script from "./ChargesStat.vue?vue&type=script&lang=js&"
export * from "./ChargesStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports